/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.14",
    versionName: "0.2.0-nightly.2025.7.14",
    versionChannel: "nightly",
    buildDate: "2025-07-14T00:09:40.200Z",
    commitHash: "864290523675b9ee79a85646219c3a15abd14c58",
};
